import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import "./style.scss";
import { useDispatch } from "react-redux";
import GlobalFeaturesSection from "./GlobalFeaturesSection";
import GeneralInfoSection from "./GeneralInfo";
import Faq from "./FAQ";
import { getSecurityDataAction } from "../../../App/actions";
import ContactUsSection from "./ContactUs";
import HeroSection from "./HeroSection";

// changed the key

function Security() {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSecurityDataAction());
  }, [dispatch]);

  return (
    <Container className="homePageAdmin">
      <div className="d-flex flex-wrap align-items-center justify-content-between titleBoxWrap mb-25">
        <h2 className="adminSectionTitle">Security Page</h2>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            history.push("/admin/pages");
          }}
        >
          <i className="fa-regular fa-arrow-left" /> Back
        </button>
      </div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="home1">
        <Row>
          <Col md={3}>
            <Nav variant="pills" className="flex-column nav-pills1">
              <Nav.Item>
                <Nav.Link eventKey="home1">General Info</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="home2">Hero Section</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="home3">Features Section</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="home4">FAQ Section</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="home5">Contact Us</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col md={9}>
            <Tab.Content className="themeTabs">
              <Tab.Pane eventKey="home1">
                <GeneralInfoSection />
              </Tab.Pane>
              <Tab.Pane eventKey="home2">
                <HeroSection />
              </Tab.Pane>
              <Tab.Pane eventKey="home3">
                <GlobalFeaturesSection />
              </Tab.Pane>
              <Tab.Pane eventKey="home4">
                <Faq />
              </Tab.Pane>
              <Tab.Pane eventKey="home5">
                <ContactUsSection />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default Security;
